import withRouteStyles from '../../HOC/withRouteStyles';
import Scroller from './Scroller';

export default withRouteStyles('scroller')(Scroller);
